const apiConfig = {
    apiUrl:process.env.VUE_APP_API_URL
}
export default apiConfig;